<template>
	<div class="BasePieChart">
		<div ref="PieChart" style="width: 100%; height: 450px; overflow: hidden;"></div>
		<!-- <div class="flex justify-around text-xs m-1">
			<p v-for="(item, index) in data" :key="index" class="mx-2 text center">{{item.value}}%</p>
		</div> -->
		<!-- <div v-else>
			<h3 style="text-align: center; padding-top: 50px;">No Data Found</h3>
		</div> -->
	</div>
</template>
<script>
var echarts = require("echarts");
import { mapGetters } from "vuex";
import { GraphData } from "../../../mixins/basePieChartGraph";
import { EventBus } from "../../eventBus";

export default {
	name: "BasePieGraph",
	mixins: [GraphData],
	data() {
		return {
			daySchdulerGraphInstance: "",
			colors: [" #e29d5a", "#F9CB9C", "#FCE5CD"],
			// colors: ["#a3a1fb","#c9daf8", "#f9acaa"],
			// colors: ["#66cc66", "#8000ff", "#ffa31a", "#80d4ff", "#b30000"],
			isGraphDataAvailable: true,
			data: []
		};
	},
	watch: {
		getGraphVisibility(newValue, oldValue){
			console.log('getGraphVisibility', newValue);
			this.reRenderGraph();
		},
		getGraphRerenderStatus(newValue, oldValue){
			console.log("calling reRender()");
			this.map_graph_data();
			this.reRenderGraph();
		}
	},
	computed: {
		...mapGetters(["getNameOfGraph","getGraphVisibility", "getGraphRerenderStatus"]),
		showAnalyticsDataOnGraph() {
			return this.$store.getters.getGraphData;
		},
		selectedView() {
			// console.log("getselectSalesView", this.$store.getters.getselectSalesView);
			return this.$store.getters.getselectSalesView;
		}
	},
	mounted() {
		this.initBaseGraph();
		this.map_graph_data();
		this.reRenderGraph();
		// EventBus.$on("callRerender", router => {
		// 	console.log("calling reRender()");
		// 	this.map_graph_data();
		// 	this.reRenderGraph();
		// });
		// EventBus.$on("getGraphDetails", data => {
		// 	console.log("data", data);
		// 	if(data){
		// 		this.map_graph_data(data);
		// 	}else{
		// 		this.clearGraph();
		// 	}
		// });
	},
	beforeDestroy() {
		EventBus.$off();
	},
	methods: {
		map_graph_data() {
			let graph_data = this.showAnalyticsDataOnGraph;
			this.graphSeries = [];
			this.graphColors = this.colors;
			this.getTitle.top = 0;
			this.getLegend.show = false;
			// this.getLegend.top = 20;
			// this.getLegend.left = "left";
			// this.getLegend.orient = 'vertical';
			// this.getLegend.type = 'scroll';
			// this.getLegend.data = this.showAnalyticsDataOnGraph.xAxisData;
			let Actual = {
				name: "",
				type: "pie",
				radius: "60%",
				center: ['55%', '50%'],
                data: [],
				label: {
					show: true,
					// position: 'center'
				},
				itemStyle: {
					normal: {
						borderColor: '#fff',
						borderWidth: '0'
					},
					emphasis: {
						borderColor: '#fff',
						borderWidth: '0'
					}
				},
			};

			if(Object.keys(this.showAnalyticsDataOnGraph).length){
				for(let i = 0; i < this.showAnalyticsDataOnGraph.xAxisData.length; i++) {
					Actual.data.push( {
					value : graph_data.series.pieValue[i],
					// value : graph_data.series.pieValue[i] == 0 ? null : graph_data.series.pieValue[i],
					name : graph_data.xAxisData[i],
					data:  graph_data.series.thisYear[i]
					})
				}

				this.graphSeries.push(Actual);
			}
			// if (graph_data.length) {
			// 	// this.data = graph_data;
			// 	xAxisData
			// } else {
			// 	this.isGraphDataAvailable = false;
			// }

			this.reRenderGraph();
			// console.log("graphData", this.graphData);
		},

		clearGraph: function() {
			this.daySchdulerGraphInstance.clear();
		},

		reRenderGraph: function() {
			this.clearGraph();
			this.daySchdulerGraphInstance.setOption(this.graphData);
			this.daySchdulerGraphInstance.hideLoading();
		},

		initBaseGraph() {
			let baseGraphContainer = this.$refs["PieChart"];
			this.daySchdulerGraphInstance = echarts.init(
				baseGraphContainer,
				null,
				this.initOptions
			);
			this.daySchdulerGraphInstance.showLoading();
		}
	}
};
</script>
<style>
	tspan{
		text-transform: capitalize;
	}
</style>
